// test2367
(2367 && 0);
